import React, { useEffect, useState } from "react";
import Sidebar from "../../../../partials/aside/Sidebar";
import { Link } from "react-router-dom";
import helpersNumbers from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersTime from "../../../../../helpers/time";
import moment from "moment";

export default function All() {
  const [gifts, setGifts] = useState([]);

  useEffect(() => {
    getGifts();
  }, []);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getGifts = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultAddGiftChargeUser = await sendRequestGetGifts();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultAddGiftChargeUser) {
      return;
    }
    setGifts(resultAddGiftChargeUser.reverse());
  };

  const sendRequestGetGifts = async () => {
    let headersRequest = getHeaderForRequest();
    let gifts;
    try {
      gifts = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/manage/gift-charge",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return gifts.data.data;
  };

  const changeActiveGift = async (giftID, giftActive) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultAddGiftChargeUser = await sendRequestChangeActiveGift(
      giftID,
      giftActive
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultAddGiftChargeUser) {
      return;
    }
    getGifts();
  };

  const sendRequestChangeActiveGift = async (giftID, giftActive) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/manage/gift-charge/${giftID}/active/${giftActive}`,
        {},
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return true;
  };

  const generateGifts = () => {
    return (
      <div className="table-responsive">
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره هدیه </td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
              <td>تعداد استفاده</td>
              <td>فعال</td>
              <td>تاریخ درج</td>
              <td>تاریخ آخرین بروزرسانی</td>
              <td>عملیات</td>
            </tr>
          </thead>
          <tbody>
            {gifts.map((gift) => {
              return (
                <tr>
                  <td>{helpersNumbers.toPersianNum(gift._id)}</td>
                  <td>
                    {helpersNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(gift.start_date) +
                        " " +
                        moment(gift.start_date).local().format("HH:mm:ss")
                    )}
                  </td>
                  <td>
                    {helpersNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(gift.end_date) +
                        " " +
                        moment(gift.end_date).local().format("HH:mm:ss")
                    )}
                  </td>
                  <td>{helpersNumbers.toPersianNum(gift.count_use)}</td>
                  <td>
                    {
                      <span
                        className={`badge  badge-${
                          gift.active ? "success" : "danger"
                        } `}
                      >
                        {gift.active ? "فعال" : "غیرفعال"}
                      </span>
                    }
                  </td>
                  <td>
                    {helpersNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(gift.created_at) +
                        " " +
                        moment(gift.created_at).local().format("HH:mm:ss")
                    )}
                  </td>
                  <td>
                    {helpersNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(gift.updated_at) +
                        " " +
                        moment(gift.updated_at).local().format("HH:mm:ss")
                    )}
                  </td>

                  <td>
                    <span className="pl-2">
                      <span
                        className={` btn 
                      btn-${gift.active ? "danger" : "primary"}
                        `}
                        title={gift.active === 1 ? "غیرفعال کردن" : "فعال کردن"}
                        onClick={() => {
                          changeActiveGift(gift._id, +!gift.active);
                        }}
                      >
                        <i
                          className={`${
                            gift.active ? "fa fa-power-off" : "fas fa-play"
                          }`}
                        ></i>
                      </span>
                    </span>

                    <span className="pl-2">
                      <Link
                        to={`/finance/manage/gift-charge-user/${gift._id}/edit/`}
                        className="btn btn-success"
                      >
                        <i className="fa fa-edit"></i>
                      </Link>
                    </span>
                    <span className="pl-2">
                      <Link
                        to={`/finance/manage/gift-charge-user/${gift._id}/ranges-value`}
                        className="btn btn-warning"
                      >
                        <i className="fa fa-money-bill"></i>
                      </Link>
                    </span>
                    <span>
                      <Link
                        to={`/finance/manage/gift-charge-user/${gift._id}/view`}
                        className="btn btn-info"
                      >
                        <i className="fa fa-info"></i>
                      </Link>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const generateDoseNotHaveGifts = () => {
    return (
      <div className="pt-2">
        <div className="alert alert-info">شما هیچ هدیه ای اضافه نکرده اید.</div>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="gift-charge-user" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  لیست هدایای افزایش اعتبار
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <span className="pl-2">
                <Link
                  className="btn btn-info"
                  to="/finance/manage/gift-charge-user/add"
                >
                  <span className="pl-2">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span>اضافه کردن هدیه افزایش اعتبار</span>
                </Link>
              </span>
              <div className="pt-2">
                {gifts.length > 0
                  ? generateGifts()
                  : generateDoseNotHaveGifts()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
